import { Alert } from '@mui/material'
import InterlocutorItem from './InterlocutorItem'
import { Divider, List } from '@material-ui/core'
export const InterlocutorsList = ({
  interlocutors,
  isError,
  interlocutorSelectedIndex,
  handleSelectInterlocutor,
}) => {
  if (isError) return null
  if (interlocutors.length === 0) {
    return (
      <Alert severity="warning">
        Aucun coproprietaire demandeur, ni prestataire de renseigné sur le
        ticket
      </Alert>
    )
  }

  return (
    <List>
      {interlocutors.map((interlocutor, index) => (
        <div key={`interlocutor-container-${index + 1}`}>
          <InterlocutorItem
            index={index}
            interlocutor={interlocutor}
            interlocutorSelectedIndex={interlocutorSelectedIndex}
            handleSelectInterlocutor={handleSelectInterlocutor}
          />
          <Divider component="li" />
        </div>
      ))}
    </List>
  )
}

export default InterlocutorsList
